namespace advisorop.components.advisor {

    class AlertCuWrapperController {

        $router;
        
        static $inject = ["identityService","generalService", "advisorService"];
        constructor(private identityService: services.IdentityService,
            private generalService: services.GeneralService, private advisorService: services.AdvisorService) {

        }

        $onInit(): void {        
        }
    }

 
    class AlertCuWrapper implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = AlertCuWrapperController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/alert-cu-wrapper.html';
        }
    }
    angular.module(Constants.APP).component("alertCuWrapper", new AlertCuWrapper());
}